import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getTicketById, updateTicket } from '../api';
import { FormField, CustomButton, Loader } from '../components';
import { uploadImage } from '../api';

const EditTicket = () => {
  const { id } = useParams(); // Get ticket ID from URL
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [form, setForm] = useState({
    title: '',
    category: '',
    description: '',
    location_link: '',
    contact_number: '',
    image_url: '',
  });
  const [file, setFile] = useState(null); // For image upload

  // Fetch ticket details on component mount
  useEffect(() => {
    const fetchTicket = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await getTicketById(token, id);
        setForm(response.data);
      } catch (error) {
        console.error('Failed to fetch ticket:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTicket();
  }, [id]);

  const handleFormFieldChange = (fieldName, e) => {
    setForm({ ...form, [fieldName]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Capture the selected file
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Upload image if a file is selected
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await uploadImage(localStorage.getItem('token'), formData);
        form.image_url = response.data.filename; // Save the filename
      }

      // Update ticket
      await updateTicket(localStorage.getItem('token'), id, form);
      alert('Ticket updated successfully');
      navigate('/profile'); // Redirect to profile after editing
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to update ticket');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-[#1c1c24] flex justify-center items-center flex-col rounded-[10px] sm:p-10 p-4">
      <h1 className="text-2xl font-bold text-white mb-6">Edit Ticket</h1>

      <form onSubmit={handleSubmit} className="w-full mt-[65px] flex flex-col gap-[30px]">
        <FormField
          labelName="Title*"
          placeholder="Write a title"
          inputType="text"
          value={form.title}
          required
          editable={true}
          handleChange={(e) => handleFormFieldChange('title', e)}
        />
        <FormField
          labelName="Category*"
          placeholder="Select a category"
          inputType="select"
          value={form.category}
          required
          editable={true}
          options={[
            'Streetlights',
            'Potholes',
            'Traffic Signals',
            'Waste Management',
            'Public Transport',
            'Water Supply',
            'Electricity',
            'Road Safety',
            'Noise Pollution',
            'Air Pollution'
          ]}
          handleChange={(e) => handleFormFieldChange('category', e)}
        />
        <FormField
          labelName="Description*"
          placeholder="Write your complaint in detail"
          isTextArea
          value={form.description}
          required
          editable={true}
          handleChange={(e) => handleFormFieldChange('description', e)}
        />
        <FormField
          labelName="Location Link (Optional)"
          placeholder="Paste a valid Google Maps URL (e.g., https://maps.app.goo.gl/...)"
          inputType="url"
          value={form.location_link}
          editable={true}
          handleChange={(e) => handleFormFieldChange('location_link', e)}
        />
        <FormField
          labelName="Contact Number (Optional)"
          placeholder="Enter contact number"
          inputType="tel"
          value={form.contact_number}
          editable={true}
          handleChange={(e) => handleFormFieldChange('contact_number', e)}
        />
        <FormField
          labelName="Upload Image (Optional)"
          placeholder="Choose an image"
          inputType="file"
          handleChange={handleFileChange}
        />

        <div className="flex justify-center items-center mt-[40px]">
          <CustomButton
            btnType="submit"
            title="Save Changes"
            styles="bg-[#1dc071]"
          />
        </div>
      </form>
    </div>
  );
};

export default EditTicket;